const  enviromentsRules =  (store, valueEval) => {
  const {
    PAYMENT_SERVICE_CONF: {isClaroPartner}, 
    canManageFavorites, 
    isContainerTelcel, 
    isAnonimous
  } = store
  const isClaroPay = !isContainerTelcel
  let enviromentValues = []
  if(isContainerTelcel){
    if(isClaroPartner){
      enviromentValues = {
        showButtonFavorites : false,
        showButtonDomiciliation : false,
        showButtonScanner: false
      }
    } else {
      enviromentValues =  {
        showButtonFavorites : false,
        showButtonDomiciliation : false,
        showButtonScanner: false
      }
    }
  }
  if(isClaroPay){
    if(isClaroPartner){
      enviromentValues = {
        showButtonFavorites : false,
        showButtonDomiciliation : false,
        showButtonScanner: false
      }
    } else {
      enviromentValues =  {
        showButtonFavorites : canManageFavorites,
        showButtonDomiciliation : true,
        showButtonScanner: true
      }
    }
  }
  return enviromentValues[valueEval]
}
export default enviromentsRules